<div class="wrapper cm-details-tab thread-wear" *ngIf="((currentVehicle$ | async) || currentVehicle) as currentVehicle">
  <div class="row equal">
    <div class="col-xs-6 mg-col">
      <oc-vehicle-schematic
        [vehicleObject]="currentVehicle"
        [maxWidth]="ocVehicleSchematicConfig.maxWidth"
        [maxHeight]="ocVehicleSchematicConfig.maxHeight"
        positionsHigh="2"
        positionsWide="5"
        [topAxle]="ocVehicleSchematicConfig.topAxle"
        [leftPos]="ocVehicleSchematicConfig.leftPos"
        [showChains]="false"
        [showRims]="false"
        [highlightSelected]="true"
        [showPositionLabels]="true"
        redraw="svgReset"
        positionView="fitted"
        [useReadingSequence]="true"
        [includeFitments]="false"
        [disabledSegments]="false"
        [(selectedComponent)]="selectedComponent"
        [buildCSS]="vehicleIssues"
        (tyreSelected)="tyreSelected($event)">
      </oc-vehicle-schematic>
    </div>
    <div class="col-xs-6 mg-col block-details" *ngIf="details">
      <!-- vehicle -->
      <div class="row d-flex">
        <div class="col-xs-6 mg-col">
          <label class="pull-right">{{"UI.Resource.Common.Vehicle"|xlat}}:</label>
        </div>
        <div class="col-xs-6 mg-col" *ngIf="vehicle.serialNo">
          <a (click)="showVehicle()">{{vehicle.serialNo}}</a>
        </div>
      </div>
      <div role="row d-flex">
        <div class="col-xs-6 mg-col">
          <label class="pull-right">{{"equipment.equipmentTypeTyre"|xlat}}:</label>
        </div>
        <div class="col-xs-6 mg-col" *ngIf="selectedComponent?.serialNumber">
          <a (click)="showSelectedTyre()">{{ selectedComponent?.serialNumber }}</a>
        </div>
        <div class="col-xs-6 mg-col" *ngIf="!selectedComponent?.serialNumber">-</div>
      </div>
      <div class="row d-flex">
        <div class="col-xs-6 mg-col">
          <label class="pull-right">{{'Last Tread Reading'}}:</label>
        </div>
        <div class="col-xs-6 mg-col" *ngIf="details.lastTreadReadingDate">{{details.lastTreadReadingDate | date: 'dd-MM-yyyy hh:mm'}}</div>
        <div class="col-xs-6 mg-col" *ngIf="!details.lastTreadReadingDate">-</div>
      </div>
      <!-- asymetric wear -->
      <div class="row d-flex">
        <div class="col-xs-6 mg-col">
          <label class="pull-right">{{ 'Active Asym Wear Alerts' }}:</label>
        </div>
        <div class="col-xs-4 mg-col" *ngIf="details.activeAsyWearAlert">{{details.activeAsyWearAlert}}</div>
        <div class="col-xs-4 mg-col" *ngIf="!details.activeAsyWearAlert">-</div>
      </div>
      <div class="row d-flex">
        <div class="col-xs-6 mg-col">
          <label class="pull-right">{{ 'Last Alert Raised' }}:</label>
        </div>
        <div class="col-xs-6 mg-col" *ngIf="details.lastAsyWearAlert">{{details.lastAsyWearAlert | date: 'dd-MM-yyyy hh:mm'}}</div>
        <div class="col-xs-6 mg-col" *ngIf="!details.lastAsyWearAlert">-</div>
      </div>
      <!-- tread matching limit  -->
      <!-- <div class="row d-flex">
        <div class="col-xs-6 mg-col">
          <label class="pull-right">{{ 'Active Matching Alert' }}:</label>
        </div>
        <div class="col-xs-6 mg-col" *ngIf="details.activeTreadMatchLimitAlert">{{details.activeTreadMatchLimitAlert}}</div>
        <div class="col-xs-6 mg-col" *ngIf="!details.activeTreadMatchLimitAlert">-</div>
      </div>
      <div class="row d-flex">
        <div class="col-xs-6 mg-col">
          <label class="pull-right">{{ 'Last Matching Alert' }}:</label>
        </div>
        <div class="col-xs-6 mg-col" *ngIf="details.lastTreadMatchLimitAlert">{{details.lastTreadMatchLimitAlert | date: 'dd-MM-yyyy hh:mm'}}</div>
        <div class="col-xs-6 mg-col" *ngIf="!details.lastTreadMatchLimitAlert">-</div>
      </div> -->
      <!-- low tread  -->
      <div class="row d-flex">
        <div class="col-xs-6 mg-col">
          <label class="pull-right">{{ 'Low Tread Tyres' }}:</label>
        </div>
        <div class="col-xs-6 mg-col" *ngIf="details.activeLowTread">{{details.activeLowTread}}</div>
        <div class="col-xs-6 mg-col" *ngIf="!details.activeLowTread">-</div>
      </div>
      <!-- worn out  -->
      <div class="row d-flex">
        <div class="col-xs-6 mg-col">
          <label class="pull-right">{{ 'Worn Out Tyres' }}:</label>
        </div>
        <div class="col-xs-6 mg-col" *ngIf="details.activeWornOut">{{details.activeWornOut}}</div>
        <div class="col-xs-6 mg-col" *ngIf="!details.activeWornOut">-</div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-xs-12 mg-col k-grid cm-overrides">
      <h3><strong>Tread Wear Alert Log</strong></h3>
      <app-custom-grid [dataView]="selectedDetails" [columns]="columns" [gridConfig]="dataGridConfig"
        (onEditGridItem)="showComponent($event)"></app-custom-grid>
    </div>
  </div>
</div>
